<template>
  <div>
    <div class="bd-header bd-header_drive2">
      <div class="bd-header__menu" @click="shift()">
        <svg height="100" viewBox="-38 -38 100 100" width="100" xmlns="http://www.w3.org/2000/svg" v-if="!isMobile" v-bind:svg-inline="''" v-bind:class="'bd-svg-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M-33-23h90c1.377 0 2.559.488 3.535 1.465S62-19.379 62-18s-.488 2.559-1.465 3.535S58.377-13 57-13h-90c-1.379 0-2.559-.488-3.535-1.465S-38-16.621-38-18s.488-2.559 1.465-3.535S-34.379-23-33-23zm0 60h90c1.377 0 2.559.488 3.535 1.465S62 40.623 62 42s-.488 2.559-1.465 3.535S58.377 47 57 47h-90c-1.379 0-2.559-.488-3.535-1.465S-38 43.377-38 42s.488-2.559 1.465-3.535S-34.379 37-33 37zm0-30h90c1.377 0 2.559.488 3.535 1.465S62 10.621 62 12s-.488 2.559-1.465 3.535S58.377 17 57 17h-90c-1.379 0-2.559-.488-3.535-1.465S-38 13.379-38 12s.488-2.559 1.465-3.535S-34.379 7-33 7z"/></svg>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 123.5 102.7" v-else="" v-bind:svg-inline="''" v-bind:class="'bd-svg-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M47.6 98.1c2.9 2.9 7.7 2.9 10.6 0 2.9-2.9 2.9-7.7 0-10.6L29.4 58.7h83.5c4.1 0 7.5-3.4 7.5-7.5s-3.4-7.5-7.5-7.5H29.4l28.8-28.8c2.9-2.9 2.9-7.7 0-10.6C56.7 2.8 54.8 2 52.9 2s-3.8.7-5.3 2.2L6 45.8c-1.4 1.4-2.2 3.3-2.2 5.3S4.6 55 6 56.4l41.6 41.7z"/></svg>
      </div>
      <div class="bd-header__title bd-ht">
        <img class="bd-ht__img" src="/pages/drive2/img/logo.png" alt="">
      </div>
    </div>
    <div class="bd-feed bd-feed_drive2">
      <div class="bd-drive2">

        <div class="bd-drive2__main-top">
          <span class="bd-drive2__main-top-line" >Завод автомобилей Мазда в Японии</span>
        </div>

        <div class="bd-drive2__container">

          <img src="/pages/drive2/img/1.jpg">

          <p class="bd-drive2__text">От своей семьи выражаю огромную
            признательность за отличную организацию нашего путешествия
            в Японию фирме Фудзи Трэвел. Это очень красивая страна, и всё
            наше пребывание в стране нас не покидало чувство,
            что мы попали в совершенно другое измерение, настолько
            сильно сразу видны различия между, например, Токио и Москвой.
          </p>

          <div class="bd-drive2__player-wrap">
            <buzzCode @ready="ready" :id="id"></buzzCode>
          </div>

          <p class="bd-drive2__text">Японцы от нас отличаются не только лицом:
            они более дружелюбны, более приветливы. Хотели посетить
            не только знаковые города Японии — Токио
            и Киото, а и те, где по сути и смотреть нечего, но в
            этих городах раскрываются таинства страны и местных жителей.
            Поэтому заехали и в Магоме с Цумаго. Это как побывать
            в российской глубинке — совсем иные впечатления. Советую всем,
            пусть даже тем, кто и не проявляет большого интереса
            к Японии, все таки побывать в этой стране, потому что ваши
            впечатления о Японии будут незабываемыми.
            Отдельное спасибо за организацию нашей экскурсии
            на завод Мазда, точнее за посещение музея Мазда
            в составе англоговорящей группы посетителей. О том, что
            такую экскурсию надо резервировать заранее мы узнали
            ещё на встрече в офисе Фудзитревел в Москве, спасибо что всё у
            нас получилось.</p>

          <img src="/pages/drive2/img/2.jpg">
          <img src="/pages/drive2/img/3.jpg">

          <p class="bd-drive2__text">Cборочный конвейер громадного
            завода Mazda в городе Хиросима растянулся на 7 километров,
            поэтому наряду с музеями автоконцернов Toyota (в городе Тойота)
            и Nissan (в городе Йокогама), компании Мазда есть чем
            гордиться и есть что показать своим приверженцам
            и посетителям! В том числе и часть самого длинного в "автомобильном
            мире" сборочного конвейера. Правда, фотографировать
            в этой части экскурсии (осмотр небольшой части сборочного
            конвейера завода Мазда, показываемую в рамках
            экскурсии) — строго запрещено! За этим японцы следят строго и просят
            выключить фото и видеоаппаратуру в этом месте.</p>
          <p class="bd-drive2__text">Автозавод Mazda занимает
            огромную территорию, с несколькими собственными
            мостами и причалами (на фото — территория завода
            Мазда обозначена желтой пунктирной линией).</p>
          <img src="/pages/drive2/img/4.jpg">
          <p class="bd-drive2__text">
            Экскурсия для англоязычных туристов бронируется
            заранее. Данный осмотр состоит из нескольких частей: посещение
            заводского музея, где представлены основные этапы
            истории Мазда, развития и ключевые модели компании; зал
            демонстрирующий новые технологии концерна и гордость
            инженеров Mazda, создавших роторно-поршневой двигатель
            "Renesis" (англ. Rotary Engine: роторный двигатель
            и Genesis: процесс становления). В этом же зале экспонируется
            Mazda 787B — первый и единственный автомобиль c
             роторно-поршневым двигателем, выигравший гонку "24 часа Ле-Мана".
             Далее следует посещение смотровой площадки
            с участком 7 километровой сборочной линии — U1 и зал "дизайна и
            разработки автомобилей Mazda". Завершает
            экскурсию "Зал будущего Mazda" с концептами автомобилей, отображающих
            возможные направления развития автомобилей
            Mazda и посещение магазина с оригинальной и эксклюзивной сувенирной
            продукцией от автоконцерна.
            <br>
            <img src="/pages/drive2/img/5.jpg">
            <br>
            В 1920 году г-н Дзудзиро Мацуда (1875-1952) создает в
            Хиросиме (Япония) компанию под названием Toyo Cork Kogyo.
            Как понятно из названия (cork — пробковое дерево),
            сначала компания занималась производством пробки. Но вскоре
            Мацуда запускает производство автомобилей, и в 1931 году
            появляется название Mazda. Оно созвучно имени "Мацуда",
            а также имени Бога мудрости и ума — Ахура Мазда.
            <br>
            <br>
            Уникальный дух завода Mazda проявился в 1945 году.
            Сразу после атомной бомбардировки Mazda активно
            участвует в восстановлении Хиросимы — завод Mazda
            практически не был поврежден взрывом и использовался
            в качестве координационного центра по управлению
            процессами восстановления и оказания помощи гражданам.
            <br>
            <br>
            Первой успешной моделью Mazda — стал трицикл
            "Mazda-Go", который поставлялся в Китай и Индию (через
            более развитую в тот момент компанию Мицубиси), где
            приобрел большую популярность благодаря своей
            неприхотливости и маневренности. "Mazda-Go" стал примером
            нестандартного мышления Mazda и "решительного"
            подхода, который был вдохновлен "духом Хиросимы",
            после атомной бомбардировки: производство
            "Mazda-Go" было остановлено всего
            на три месяца, сборочный конвейер заработал уже
            к концу ноября 1945 года. В 1950-х годах "Mazda-Go"
            выпускалась уже в более модифицированном варианте — "Mazda GB".
          </p>
        </div>
      </div>
      <div class="bd-drive2-footer">
      </div>
    </div>
  </div>
</template>

<script>
import buzzCode from '@/components/buzzCode.vue';
import { isMobile } from 'mobile-device-detect';


export default {
  name: 'drive2',
  data() {
    return {
      isMobile,
    };
  },
  props: {
    id: {
      type: String,
    },
  },
  components: {
    buzzCode,
  },
  methods: {
    ready() {
      this.$emit('ready');
    },
    shift() {
      if (isMobile) {
        this.$emit('shift');
      }
    },
  },
};
</script>

<style scoped lang='stylus'>

fontSize(size, lineHeight)
  font-size ((size*0.0625)rem)
  line-height ((lineHeight/size)em)

img
  display block
  width 100%
  height auto

.bd
  &-header
    transition margin .4s
    display flex
    flex-flow row nowrap
    position fixed
    z-index 99997
    align-items center
    align-content space-around
    width 100%
    height 60px
    &_hide
      margin-top -60px
    &__menu
      width 30px
      height 20px
      margin 15px
      svg
        width 100%
        height 100%
        display block
    &__title
      width 100%
      text-align center
  &-feed
    box-sizing border-box
    width 100%
    height 100%
    min-height 100%
    padding-top 60px
  &-header
    display flex
    flex-flow row nowrap
    position fixed
    z-index 999
    align-items center
    align-content space-around
    width 100%
    &_drive2
      height 52px !important
      border-bottom 1px solid rgba(170,170,170,0.5)
      background-color rgba(0,0,0,.9)
      float right
      & ^[1]__menu
        fill white
      .bd-ht__img
        width 124px
        height auto
        float right
    &__menu
      -webkit-tap-highlight-color transparent
      outline none
  &-svg-icon
    -webkit-tap-highlight-color transparent
    outline none
  &-feed
    box-sizing border-box
    width 100%
    height 100%
    min-height 100%
    padding-top 60px
  &-drive2
    margin 0 10px 10px
    text-align left
    & p
      margin 0
    &__main-top
      padding 10px 0 7px
      font-size 17px
      font-weight 700
      line-height 1.25
    &__main-bottom
      display flex
      box-shadow 0 0 0 1px #eee, 0 4px 25px rgba(0,0,0,.07)
      margin-left -10px
      margin-right -10px
      padding 10px
      font-size 13px
      &-img
        width 85px
        flex-shrink 0
      &-img img
        display block
        width 100%
        height auto
        border-radius 50%
      &-text
        flex 1 1 auto
        min-width 0
        margin-top 0
        margin-left 10px
    &__two-days
      margin-left 5px
      color grey
      font-size 9px
    &__bishkek
      color grey
      font-size 13px
    &__text
      margin 15px 10px 20px 0px
      font-size 15px
      line-height 1.5
      color #333
      font-family sans-serif
    &__container img
      display block
      width calc(100% + 20px)
      height auto
      margin-left -10px
      margin-top 9px
      margin-bottom 9px
    &-footer
      height 40px
      padding 0 10px
      background #dcdcdc
      font-size 15px
      line-height 1.4
    &__player-wrap
      width calc(100% + 10px)
      margin 20px 0 20px -5px

</style>
